import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddWorkGalleryLayer from "../components/AddWorkGalleryLayer";

const AddWorkGalleryPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Gallery Add' />

        {/* AddWorkgalleryLayer */}
        <AddWorkGalleryLayer />
      </MasterLayout>
    </>
  );
};

export default AddWorkGalleryPage;
